<template>
  <div>
    <v-dialog v-model="dialog" width="900" persistent scrollable>
      <v-card tile>
        <v-card-title class="justify-space-between pb-4">
          <v-btn icon disabled><v-icon>mdi-clear</v-icon></v-btn>
          <span style="font-size: 20px; color: #00a99d; font-weight: bold"
            >ยืนยันรายการยาจ่ายยา
          </span>
          <v-btn icon @click="close()" small>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- <v-divider></v-divider> -->
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <div class="pt-6 pl-3">
                <span class="font-18 w-700 text-00a99d"
                  >แพทย์ที่จ่ายยา:
                  <span class="font-18 w-700 text-grey-70">{{
                    itemPrescription.nurse_name
                  }}</span></span
                >
              </div>
            </v-col>
            <v-col cols="6">
              <div class="pt-6 pl-3">
                <span class="font-18 w-700 text-00a99d"
                  >วันที่
                  <span class="font-18 w-700 text-grey-70">
                    {{ displayDate(itemPrescription.createdAt) }}</span
                  ></span
                >
              </div>
            </v-col>
            <v-col cols="12" class="d-flex flex-column">
              <v-row>
                <v-col cols="12">
                  <div class="d-flex align-center">
                    <span
                      class="pr-2"
                      style="font-size: 14px; font-weight: bold; color: #00a99d"
                    >
                      ข้อมูลพนักงาน
                    </span>
                    <v-divider
                      class="mt-1"
                      style="background-color: #ceefed"
                    ></v-divider>
                  </div>
                </v-col>
                <v-col>
                  <v-row class="pa-0 mx-0 bg-D5EEED">
                    <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                      <span class="custom-text">รหัสพนักงาน : </span>
                      <span class="custom-text ml-2">
                        {{
                          selectPatient.employee_id
                            ? selectPatient.employee_id
                            : "-"
                        }}
                      </span>
                    </v-col>
                    <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                      <span class="custom-text">แผนก : </span>
                      <span class="custom-text ml-2">
                        {{
                          selectPatient.department
                            ? selectPatient.department
                            : "-"
                        }}
                      </span>
                    </v-col>
                    <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                      <span class="custom-text">ชื่อ-สกุล : </span>
                      <span class="custom-text ml-2">{{
                        selectPatient.fullname || ""
                      }}</span>
                    </v-col>
                    <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                      <span class="custom-text">หมายเลขโทรศัพท์ : </span>
                      <span class="custom-text ml-2">{{
                        selectPatient.mobile
                      }}</span>
                    </v-col>
                    <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                      <span class="custom-text">เพศ : </span>
                      <span class="custom-text ml-2">{{
                        genderPerson(selectPatient.account_title_th)
                      }}</span>
                    </v-col>
                    <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                      <span class="custom-text">วัน/เดือน/ปีเกิด : </span>
                      <span class="custom-text ml-2">{{
                        formatDate(selectPatient.birth_date)
                      }}</span>
                    </v-col>
                    <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                      <span class="custom-text">อายุ : </span>
                      <span class="custom-text ml-2">{{
                        ageCalcilar(selectPatient.birth_date)
                      }}</span
                      ><span class="custom-text ml-2">ปี</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" lg="12" class="d-flex flex-column mb-1">
              <div>
                <v-col cols="12" class="font-20 w-700 pb-2 pr-0 pl-0">
                  <div
                    v-if="
                      itemPrescription &&
                      itemPrescription.drug_list.length !== 0
                    "
                  >
                    <div class="d-flex align-center">
                      <span
                        class="pr-2"
                        style="
                          font-size: 14px;
                          font-weight: bold;
                          color: #00a99d;
                        "
                      >
                        ข้อมูลรายการยา
                      </span>
                      <v-divider
                        class="mt-1"
                        style="background-color: #ceefed"
                      ></v-divider>
                    </div>
                    <v-row
                      class="ma-0 pa-0 mb-3 pt-2"
                      style="border-bottom: 1px #313b41 solid"
                      v-if="itemPrescription.drug_list.length >= 0"
                    >
                      <v-col class="pa-1" cols="1" align="center">
                        <span class="w-300 font-18 text-313B41"> </span>
                      </v-col>
                      <v-col class="pa-1" cols="1">
                        <span class="w-300 font-18 text-00A99D">#</span>
                      </v-col>
                      <v-col class="pa-1" cols="4">
                        <span class="w-300 font-18 text-00A99D">รายการยา</span>
                      </v-col>
                      <v-col class="pa-1" cols="2" align="center">
                        <span class="w-300 font-18 text-00A99D">จำนวน</span>
                      </v-col>
                      <v-col class="pa-1" cols="2" align="center">
                        <span class="w-300 font-18 text-00A99D">ราคา</span>
                      </v-col>
                      <v-col class="pa-1" cols="2" align="center">
                        <span class="w-300 font-18 text-00A99D">ราคารวม </span>
                      </v-col>
                    </v-row>
                    <v-row
                      class="ma-0 pa-0"
                      v-for="(item, index) in itemPrescription.drug_list"
                      :key="index"
                    >
                      <v-col class="pa-2 mb-4" cols="1" align-self="center">
                        <v-checkbox
                          v-model="selectedDrugs"
                          :value="item._id"
                          hide-details
                          dense
                          color="#00a99d"
                          style="transform: scale(1.3)"
                        />
                      </v-col>
                      <v-col class="pa-1 mb-2" cols="1" align-self="center">
                        <span class="w-300 font-18 text-313B41">{{
                          index + 1
                        }}</span>
                      </v-col>
                      <v-col class="pa-1" cols="4">
                        <span class="w-300 font-18 text-313B41">
                          <v-text-field
                            class="text-field"
                            :value="item.name_drug"
                            outlined
                            dense
                            small
                            readonly
                            hide-details
                          ></v-text-field>
                        </span>
                      </v-col>
                      <v-col class="pa-1" cols="2" align="center">
                        <span class="w-300 font-18 text-313B41">
                          <v-text-field
                            class="text-field"
                            v-model="item.count"
                            outlined
                            dense
                            small
                            readonly
                            hide-details
                            :min="0"
                          ></v-text-field>
                        </span>
                      </v-col>
                      <v-col class="pa-1 text-center" cols="2" align="center">
                        <span class="w-300 font-18 text-313B41">
                          <v-text-field
                            class="text-field"
                            :value="item.price"
                            outlined
                            dense
                            small
                            readonly
                            hide-details
                          ></v-text-field>
                        </span>
                      </v-col>
                      <v-col
                        class="pa-1"
                        cols="2"
                        align="center"
                        text-align="center"
                      >
                        <span class="w-300 font-18 text-313B41">
                          <v-text-field
                            class="text-field"
                            :value="totalToFixed(item.total)"
                            outlined
                            dense
                            small
                            readonly
                            hide-details
                          ></v-text-field>
                        </span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        class="pa-1 d-flex align-end justify-end"
                        cols="12"
                      >
                        <v-checkbox
                          v-model="selectAllDrugs"
                          @change="toggleSelectAll"
                          hide-details
                          dense
                          color="#00a99d"
                          style="transform: scale(1.3)"
                        />
                        <span class="font-16">เลือกทั้งหมด</span>
                      </v-col></v-row
                    >
                    <v-row class="ma-0 pa-0">
                      <v-col class="pa-1" cols="1" text-align="center"></v-col>
                      <v-col cols="12" class="d-flex justify-center">
                        <span
                          >สรุปยอดรายการยา
                          {{ netprice(itemPrescription) }} บาท</span
                        >
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                  </div>
                  <div v-if="itemPrescription.drug_list.length == 0">
                    <v-row class="pa-0 ma-0">
                      <v-col
                        cols="12"
                        class="noitems d-flex justify-center align-center text-center"
                      >
                        <span class="font-32 w-700">ไม่มีข้อมูลรายการยา</span>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </div>
            </v-col>
            <v-col>
              <v-row align="center" justify="center"
                ><v-col cols="5" sm="4" md="3"
                  ><v-btn
                    class="rounded-lg"
                    block
                    color="#00a99d"
                    outlined
                    @click="close"
                    >ยกเลิก</v-btn
                  ></v-col
                ><v-col cols="5" sm="4" md="3"
                  ><v-btn
                    class="rounded-lg"
                    block
                    dark
                    depressed
                    color="#00a99d"
                    :loading="btn_loading"
                    @click="save()"
                    >ยืนยัน</v-btn
                  ></v-col
                ></v-row
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
// import functioncryto from "@/services/encrypt.js";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      dialog: false,
      search: "",
      btn_loading: false,
      patient: [],
      // itemPrescription: {
      //   name_drug: "ทดสอบ",
      //   drug_list: [
      //     {
      //       _id: "682562c81b9022001218e63a",
      //       drug_id: "99999",
      //       name_drug: "ยาแก้ไอ ตรา อาปาเช่",
      //       price: 20,
      //       unit: "ขวด",
      //       biz_id: "324265892276395",
      //       quantity: 15,
      //       createdAt: "2025-05-15T03:43:04.932Z",
      //       updatedAt: "2025-05-16T08:05:14.319Z",
      //       __v: 0,
      //       total: 300,
      //       count: "15",
      //       status: true
      //     },
      //     {
      //       _id: "647f03b353b5ca37d0b758d9",
      //       drug_id: "1543205",
      //       name_drug: "0.02% Triamcinolone milk lotion (60ml)",
      //       usage: "ทาทุกวันเช้าและเย็น",
      //       price: 40,
      //       unit: "ขวด",
      //       advice: "ยาใช้ภายนอกห้ามรับประทาน",
      //       biz_id: "324265892276395",
      //       createdAt: "2023-06-06T10:00:19.336Z",
      //       updatedAt: "2025-05-06T10:05:21.293Z",
      //       __v: 0,
      //       quantity: 5771,
      //       total: 40,
      //       count: 1,
      //       status: true
      //     },
      //     {
      //       _id: "647f03b353b5ca37d0b75844",
      //       drug_id: "1543205",
      //       name_drug: "0.02% Triamcinolone milk lotion (60ml)",
      //       usage: "ทาทุกวันเช้าและเย็น",
      //       price: 40,
      //       unit: "ขวด",
      //       advice: "ยาใช้ภายนอกห้ามรับประทาน",
      //       biz_id: "324265892276395",
      //       createdAt: "2023-06-06T10:00:19.336Z",
      //       updatedAt: "2025-05-06T10:05:21.293Z",
      //       __v: 0,
      //       quantity: 5771,
      //       total: 40,
      //       count: 1,
      //       status: false
      //     },
      //   ],
      // },
      selectedDrugs: [],
      selectPatient: {},
      itemPrescription: [],
    };
  },
  async mounted() {
    this.getPrescription();
  },
  computed: {
    formattedItemText() {
      return (item) => {
        if (item.employee_id) {
          return `${item.fullname} ( ${item.employee_id} )`;
        } else {
          return item.fullname;
        }
      };
    },
    selectAllDrugs: {
      get() {
        return (
          this.selectedDrugs.length ===
            this.itemPrescription.drug_list.length &&
          this.itemPrescription.drug_list.length > 0
        );
      },
      //   set(value) {
      //     // This setter is needed for v-model, but the actual logic is in toggleSelectAll
      //   },
    },
  },
  methods: {
    open(item) {
      this.selectPatient = item.patient;
      this.dialog = true;
      this.getPrescription();
    },
    close() {
      this.dialog = false;
      this.search = "";
      this.itemPrescription.drug_list = [];
      // this.itemPrescription = {};
      this.selectedDrugs = [];
      this.selectPatient = {};
    },
    async getPrescription() {
      try {
        const params = new URLSearchParams();
        params.append("page", 1);
        params.append("limit", 10);
        if (
          this.selectPatient.one_id !== "" &&
          this.selectPatient.one_id !== null
        ) {
          params.append("patient_id", this.selectPatient.one_id);
        } else {
          params.append("patient_cid", this.selectPatient.cid);
        }
        params.append("biz_id", sessionStorage.biz_id);
        params.append("status", "waiting");
        let { data: { data } = {} } = await this.axios.get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/prescription?${params}`
        );
        if (data[0]) {
          const { data: searchData } = data[0];
          this.itemPrescription = searchData[0];
        }
      } catch (error) {
        console.error();
      }
    },
    quantity(itemDrug) {
      let quantity = 0;
      itemDrug.forEach((ele) => {
        if (ele.list_drug !== "" && ele.count !== "") {
          quantity++;
        }
      });
      return quantity;
    },
    netprice(itemDrug) {
      let netprice = 0;
      itemDrug.drug_list.forEach((ele) => {
        if (ele.count !== "") {
          netprice += Number(ele.count) * Number(ele.price);
        }
      });
      return netprice.toFixed(2);
    },
    async save() {
      try {
        this.itemPrescription.drug_list = this.itemPrescription.drug_list.map(
          (drug) => {
            return {
              ...drug,
              status: this.selectedDrugs.includes(drug._id),
            };
          }
        );
        const payload = {
          prescription_id: this.itemPrescription.prescription_id,
          drug_list: this.itemPrescription.drug_list,
          his_id: this.itemPrescription.his_id,
          biz_id: sessionStorage.biz_id,
        };
        await this.axios
          .post(
            `${process.env.VUE_APP_BACKEND_URL}/v1/prescription-status`,
            payload
          )
          .then((res) => {
            if (res.data.result === "success") {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "ยืนยันรายการยาสำเร็จ",
                showConfirmButton: false,
                timer: 3000,
              });
              // location.reload();
              // this.dialog = false;
            } else {
              Swal.fire({
                position: "center",
                icon: "error",
                title: "ยืนยันรายการยาไม่สำเร็จ",
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });
        this.$emit("success");
        this.close();
      } catch (err) {
        console.log(err);
      }
    },

    totalToFixed(item) {
      if (item) {
        return item.toFixed(2);
      }
      return null;
    },
    toggleSelectAll() {
      if (this.selectAllDrugs) {
        // If select all is checked, uncheck all
        this.selectedDrugs = [];
      } else {
        // If select all is unchecked, check all
        this.selectedDrugs = this.itemPrescription.drug_list.map(
          (item) => item._id
        );
      }
    },
    ageCalcilar(birth) {
      const today = new Date();
      const birthDate = new Date(birth);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      return age;
    },
    formatDate(data) {
      if (!data) {
        return null;
      }

      let datetime = new Date(
        new Date(data) - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, -1)
        .substr(0, 10);
      var [year, month, day] = datetime.split("-");
      return `${day}/${month}/${parseInt(year) + 543}`;
    },
    genderPerson(account_title_th) {
      if (account_title_th) {
        if (["เด็กชาย", "นาย"].includes(account_title_th)) return "ชาย";
        if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
          return "หญิง";
      } else {
        return "";
      }
    },
    displayDate(date) {
      if (!date) return "-";
      return moment(date)
        .locale("th")
        .add(543, "years")
        .format("DD MMMM YYYY HH:mm น.");
    },
  },
};
</script>

<style scoped>
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.usageAndAdvice {
  border: 1px solid #00000061;
  border-radius: 4px;
  margin: 0px;
}
.custom-autocomplete {
  border-radius: 6px;
}
.custom-text {
  font-size: 16px;
  color: black;
}

.v-list-item-group .v-list-item--active {
  background: #4ba69d;
  color: #fff;
}
.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  background: #d5eeed;
}

.custom-checkbox .v-selection-control {
  height: 50px;
  width: 50px;
}
.custom-checkbox .v-icon {
  font-size: 16px; /* ปรับขนาด icon */
}
</style>
